<template>
  <div>
    <p cols="3" class="font font--color_light information">
      По{{'\xa0'}}всем вопросам вы{{'\xa0'}}можете связаться с{{'\xa0'}}нами по{{'\xa0'}}телефону:
      <a href="tel:88004441085" class="font">8{{'\xa0'}}(800){{'\xa0'}}444-10-85 </a>
      (c{{'\xa0'}}9:00 до{{'\xa0'}}18:00 по{{'\xa0'}}Москве) или написать на{{'\xa0'}}почту:
      <a href="mailto:agent@modulbank.ru">agent@modulbank.ru</a>
    </p>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.information {
  text-align: center;
  line-height: 2;
}
</style>
